module.exports = __webpack_public_path__ + "img/icon_personal.7036a928.svg";